export const GET_HAIR_PRESCRIPTION_LINK_DATA =  'GET_HAIR_PRESCRIPTION_LINK_DATA'
export const GET_HAIR_PRESCRIPTION_LINK_DATA_SUCCESS =  'GET_HAIR_PRESCRIPTION_LINK_DATA_SUCCESS'
export const GET_HAIR_PRESCRIPTION_LINK_DATA_ERROR =  'GET_HAIR_PRESCRIPTION_LINK_DATA_ERROR'
export const CLEAR_HAIR_PRESCRIPTION_LINK_DATA =  'CLEAR_HAIR_PRESCRIPTION_LINK_DATA'